import React from "react";
import { ReactComponent as AudioIcon } from "@/assets/icons/audio-bold.svg";
import { ReactComponent as DeleteIcon } from "@/assets/icons/delete.svg";
import Utils from "@/utils";
import "@/assets/audioExtractor.less";

const AudioCompressWorkListRender = ({ audioExtractorFile, deleteAudioExtractFile }) => {
  return (
    <div className="step-cont">
      <div className="list">
        {audioExtractorFile ? (
          <div className="item" key={audioExtractorFile.guid}>
            <div className="info">
              <AudioIcon />
              <span>{Utils.omissionString(audioExtractorFile.name, 5, 7)}</span>
            </div>
            <span>{(audioExtractorFile.size / 1024 / 1024).toFixed(2)}MB</span>
            <DeleteIcon className="close" onClick={deleteAudioExtractFile} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AudioCompressWorkListRender;
